const GlobalMixin = {

      methods: {
        $showSpinner(message) {
            this.$events.$emit('spinner.show', {
                message: message
            });
        },

        $hideSpinner() {
            this.$events.$emit('spinner.hide');
        },

        $showAlert(message, action) {
            this.$events.$emit('alert.show', {
                message: message,
                action: action
            });
        },

        $showQuotationCreate(params = {}) {
            this.$events.$emit('quotation.create.show', params);
        },

        $notifyOfferCreate(offer) {
            this.$events.$emit('offer.created', offer);
        },

        $sortByName(elements) {
            return elements.sort((a, b) => {
                if(a.name < b.name) {
                    return -1
                } else if(a.name == b.name) {
                    return 0
                } else {
                    return 1
                }
            })
        }
      }

    }

export default GlobalMixin
